import { render, staticRenderFns } from "./department_list.vue?vue&type=template&id=781c8ced&scoped=true"
import script from "./department_list.vue?vue&type=script&lang=js"
export * from "./department_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c8ced",
  null
  
)

export default component.exports